/**
 * Validation constants for currency and exchange rate operations
 *
 * @feature Currency (Local / USD)
 * @since 2025.1.0
 */
export const DEFAULT_LOCAL_CURRENCY = 'USD';

/**
 * Exchange rate validation constants
 */
export const EXCHANGE_RATE_VALIDATION = {
  /** Maximum number of invalid rows to display in SNS notifications for readability */
  MAX_DISPLAYED_INVALID_ROWS: 5,
  /** Maximum number of invalid rows to display in UI notifications */
  MAX_UI_DISPLAYED_INVALID_ROWS: 10
} as const;

/**
 * Data processing constants
 */
export const DATA_PROCESSING = {
  /** Default chunk size for processing large datasets */
  DEFAULT_CHUNK_SIZE: 1000,
  /** Maximum chunk size for memory optimization */
  MAX_CHUNK_SIZE: 5000,
  /** Minimum chunk size for efficiency */
  MIN_CHUNK_SIZE: 100,
  /** Delay between chunk processing to allow event loop processing (ms) */
  CHUNK_PROCESSING_DELAY: 0
} as const;

/**
 * Error handling constants
 */
export const ERROR_HANDLING = {
  /** Maximum number of retry attempts for failed operations */
  MAX_RETRY_ATTEMPTS: 3,
  /** Base delay for exponential backoff in retry operations (ms) */
  RETRY_BASE_DELAY: 1000,
  /** Maximum delay for retry operations (ms) */
  MAX_RETRY_DELAY: 10000
} as const;
